import { render, staticRenderFns } from "./ResultsCombined.vue?vue&type=template&id=394a9a71"
import script from "./ResultsCombined.vue?vue&type=script&lang=ts"
export * from "./ResultsCombined.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports